import { createColumnHelper } from '@tanstack/react-table';
import { ChannelRuleSteps } from '../ChannelRuleModal/ChannelRuleModalContent';
import { Bin, CalculationIcon, EllipsisMenu, IOption, RoundingIcon, LinkButton } from '@weareopenr/component-library';
import styles from './PriceSchemeChannelRulesTab.module.scss';
import { CREATE_CHANNEL_RULE } from './constants';
import { IPriceRule } from 'src/types/price.types';
import { sharedTableColumns } from 'src/utils/priceRules/tableColumns';

const columnHelper = createColumnHelper<IPriceRule>();

type TTableColumnsHelper = {
  setModalOpen: () => void;
  handleEdit: (id: string, step: ChannelRuleSteps) => void;
  handleDelete?: (id: string) => void;
  allChannelsInUse: boolean;
};

export const getChannelRulesTableColumns = ({
  setModalOpen,
  handleEdit,
  handleDelete,
  allChannelsInUse,
}: TTableColumnsHelper) => [
  columnHelper.accessor('external_system.name', {
    header: 'Channel',
    size: 200,
    footer: () => {
      return (
        <LinkButton disabled={allChannelsInUse} onClick={setModalOpen} type="button">
          {CREATE_CHANNEL_RULE}
        </LinkButton>
      );
    },
  }),
  ...sharedTableColumns(),
  columnHelper.display({
    id: 'actions',
    size: 80,
    cell: (info) => {
      const { price_rule_id } = info.row.original;
      const ellipsisOptions: IOption[] = [
        {
          id: 'edit-calculation',
          name: 'Edit Calculation',
          onOptionClick: () => handleEdit(price_rule_id, ChannelRuleSteps.Adjustment),
          icon: CalculationIcon,
        },
        {
          id: 'edit-rounding',
          name: 'Edit Rounding',
          onOptionClick: () => handleEdit(price_rule_id, ChannelRuleSteps.Rounding),
          icon: RoundingIcon,
        },
        { id: 'delete-divider', isDivider: true },
        {
          id: 'delete-rule',
          name: 'Delete Channel Rule',
          onOptionClick: () => handleDelete(price_rule_id),
          icon: Bin,
          hoverColour: 'tomato',
        },
      ];
      return (
        <div className={styles['ellipsis-menu-container']}>
          <EllipsisMenu options={ellipsisOptions} variant="ghost" hoverStyle="high-contrast" />
        </div>
      );
    },
  }),
];
